var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.inited)?_c('div',[(_vm.isMobileScreen)?_c('ylCapitalMobile',_vm._b({attrs:{"info":_vm.info}},'ylCapitalMobile',_vm.$attrs,false)):_c('ylCapitalPC',_vm._b({attrs:{"info":_vm.info}},'ylCapitalPC',_vm.$attrs,false))],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }